/**
 * Component: Product Video
 */
export default class BundleList {

    constructor() {
        this.selectors = {
            root: '.product-overview__bundle',
            list: '[data-bundle-list]',
            card: '.product-overview__bundle-card'
        };

        this.$rootElement = $(this.selectors.root);
        this.$list = $('' + this.selectors.root + ' ' + this.selectors.list);
        this.$card = $('' + this.selectors.list + ' ' + this.selectors.card);
        this.init();
    }

    init() {
        this.$card.on('click', (event) => {
            event.preventDefault();
            this.$card.removeClass('active');
            const targetNode = event.currentTarget;
            var textContent = targetNode.children[0].dataset.value;
            targetNode.classList.add('active');
            $('.product-overview__attributes .custom-select-pdp option[value="' + textContent + '"]').prop('selected', true);
            $('.product-overview__attributes .custom-select-pdp').trigger('change');
        });
    }
}
